/*

? First, let's import the interface that will describe the shape of our chat object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the chat object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const broadcast_recipient: StateInterface["broadcast_recipient"] = {
	_id: "",
	broadcast_id: "",
	status: "", // e.g., "pending", "delivered"
	delivered_at: new Date("2100-01-01T00:00:00.000Z"), // Placeholder date
	recipient: {
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
		invite_status: "",
		invite_accepted_or_rejected_at: "",
	},
	is_read: false,
	read_at: "",
	created_at: "",
	updated_at: "",
	is_deleted: false,
	deleted_at: "",
};
